//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { only } from './utils/helpers';
import DropdownBox from "./utils/DropdownBox";

export default {
    name: `FlexSelect`,
    components: {
        DropdownBox,
    },
    props: {
        options: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: '',
        },
        selected: {
            type: String,
            required: false,
            default: '',
        },
        placeholder: {
            type: String,
            required: false,
        },
        searchable: {
            type: Boolean,
            required: false,
            default: false,
        },
        name: {
            type: String,
            required: false,
        },
        id: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            boxState: false,
            items: this.options,
            selectedValue: this.selected,
        }
    },
    watch: {
        items: {
            immediate: true,
            deep: true,
            handler() {
                setTimeout( () => {
                    this.$forceUpdate();
                }, 500 );
            }
        },

        options: {
            immediate: true,
            deep: true,
            handler() {
                setTimeout( () => {
                    this.$forceUpdate();
                }, 500 );
            }
        },
    },
    methods: {
        formattedValue() {
            const value = this.items[ this.selectedValue ] || this.selectedValue || this.placeholder || Object.values( this.items ).find( (el, i) => i === 0 ) || Object.values( this.options ).find( (el, i) => i === 0 );

            return value.trim().replace(/&nbsp;/gm, '');
        },

        reset() {
            this.items = this.options;

            this.$nextTick( () => {
                if ( this.$refs.input ) {
                    this.$refs.input.value = '';
                }
            } );
        },

        openBox() {
            this.boxState = true;

            this.reset();

            this.$nextTick( () => {
                if ( this.$refs.input ) {
                    this.$refs.input.focus();

                    if ( window.innerWidth <= 768 ) {
                        const scrollY = this.$refs.input.getBoundingClientRect().top + window.scrollY - 90;

                        scroll( {
                            top: scrollY,
                            behavior: "smooth"
                        } );
                    }
                }
            });
        },

        closeBox() {
            this.boxState = false;
        },

        handleItem(value) {
            this.closeBox();
            this.$emit( 'input', value );
            this.$refs.select.value = value;
            this.selectedValue = value;

            this.$forceUpdate();
        },

        handleFilter() {
            const value = this.$refs.input.value;

            this.items = only( this.options, Object.keys( this.options ).filter( ( key ) => {
                return key.includes( value ) || this.options[ key ].toLowerCase().includes( value );
            } ) );

            this.$emit( 'search', value );
        },

        handleClick() {
            this.boxState ? this.closeBox() : this.openBox();
        },

        handleClickOutside(event) {
            const path = event.path || event.composedPath();

            if ( this.$el !== path[ 1 ] ) {
                this.closeBox();
            }
        },
    },
}
